import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { PipesModule } from '../../../../shared';
import { CheckboxModule } from '../../../../shared/components/checkbox/checkbox.module';
import { CatalogFilterFacetComponent } from './catalog-filter-facet.component';

@NgModule({
  declarations: [CatalogFilterFacetComponent],
  exports: [CatalogFilterFacetComponent],
  imports: [CommonModule, NzIconModule, CheckboxModule, NgbCollapseModule, I18nModule, FormsModule, PipesModule],
})
export class CatalogFilterFacetModule {}
